import { FaroPopover } from "@faro-lotv/flat-ui";
import { Box, Grid, Stack } from "@mui/material";
import { useCanUsePhotogrammetry } from "@pages/data-management/data-management-utils";
import { DataTypeComponent } from "@pages/data-management/data-type-component";
import { isAlphaTestingEnabledSelector, isDevModeEnabledSelector } from "@store/app/app-selector";
import { useAppSelector } from "@store/store-helper";

interface Props {
  /** Reference to the popover anchor element. */
  popoverRef: React.MutableRefObject<HTMLDivElement | HTMLAnchorElement | null>;
  /** Flag to control the visibility of the popover. */
  isShowPopover: boolean;
  /** Callback to set the visibility of the popover. */
  setIsShowPopover: React.Dispatch<React.SetStateAction<boolean>>;
}

/** Popover that displays the supported data types for the import. */
export function DataTypePopover({
  popoverRef,
  isShowPopover,
  setIsShowPopover,
}: Props): JSX.Element {
  const isDevModeEnabled = useAppSelector(isDevModeEnabledSelector);
  const isAlphaTestingEnabled = useAppSelector(isAlphaTestingEnabledSelector);
  const canUsePhotogrammetry = useCanUsePhotogrammetry();

  return (
    <FaroPopover
      dark
      anchorEl={popoverRef.current}
      open={isShowPopover}
      onClose={() => setIsShowPopover(false)}
      title="Supported data types"
      showCloseButton={false}
      description={
        <Stack>
          <Box sx={{ mb: "20px" }}>
            Browse and upload supported folders from your file manager.
          </Box>

          <Grid container
            rowSpacing={3}
            sx={{
              width: "100%",
              justifyContent: "space-evenly",
              mb: "5px",
          }}>
            <Grid item>
              <DataTypeComponent caption="Blink scans" />
            </Grid>

            {isDevModeEnabled && (
              <Grid item>
                <DataTypeComponent caption="Focus scans" />
              </Grid>
            )}

            {isAlphaTestingEnabled && (
              <Grid item>
                <DataTypeComponent caption="Orbis scans" />
              </Grid>
            )}

            {canUsePhotogrammetry && (
              <Grid item>
                <DataTypeComponent caption="Photogrammetry data" />
              </Grid>
            )}
          </Grid>
        </Stack>
      }
    />
  );
}
